export default function IcoVheart(props: IcoVheartProps) {
  return (
    <div className="h-4 w-4">
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M 13.936 3.573 C 13.897 3.528 13.855 3.484 13.813 3.442 C 13.77 3.399 13.727 3.358 13.682 3.317 C 12.26 2.02 10.051 2.062 8.679 3.442 L 7.939 4.187 L 7.198 3.442 C 5.825 2.062 3.618 2.022 2.194 3.319 C 2.149 3.359 2.106 3.4 2.063 3.442 C 2.021 3.484 1.981 3.528 1.94 3.573 C 1.332 4.245 1 5.108 1 6.023 C 1 6.999 1.377 7.914 2.063 8.603 L 5.371 11.927 L 6.44 13.002 C 6.853 13.417 7.395 13.625 7.937 13.625 C 8.48 13.625 9.022 13.417 9.435 13.002 L 13.812 8.603 C 14.498 7.914 14.875 6.997 14.875 6.023 C 14.878 5.108 14.545 4.245 13.936 3.573 Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

IcoVheart.defaultProps = {};

interface IcoVheartProps {}
